const Expander = () => {
    document.getElementById('main-nav').classList.add('expanded')
    document.getElementById('moduleOverlay').classList.add('enabled')
}

export default Expander